/* ULS machine page (R2): sections/abi-uls-system-page.liquid, template product.uls-system, prefix .usp.
   1. The gallery: thumbnails switch the stage; a video is embedded only when its thumbnail is chosen.
   2. Same-page links (#usp-quote) scroll natively: Webflow's anchor handler is removed (as uls-part-pdp.js and the migration page).
   3. The quote form #usp-quote, sent to Web3Forms the way the ULS Systems quote form (assets/abi-uls-systems.js) and the migration
      page (assets/abi-legacy-migration.js) are: FormData by fetch, the section's access key, a botcheck honeypot, a reference
      (SQ-XXXXXXX, as the Systems form), and on success the GA4 event abi_quote_submitted with form_id 'uls-system-page'.
   No price is read or sent: this page has none. */
(function () {
  'use strict';

  var ENDPOINT = 'https://api.web3forms.com/submit';
  var MIN_PAGE_AGE = 1500;
  var TIMEOUT = 20000;
  var FORM_ID = 'uls-system-page';

  function clean(value) { return String(value == null ? '' : value).replace(/\s+/g, ' ').trim(); }
  function cleanLines(value) { return String(value == null ? '' : value).replace(/\r\n?/g, '\n').replace(/[ \t]+\n/g, '\n').trim(); }
  function all(scope, selector) { return Array.prototype.slice.call(scope.querySelectorAll(selector)); }
  function safeFocus(node, noScroll) { try { node.focus({ preventScroll: !!noScroll }); } catch (e) { try { node.focus(); } catch (ignore) { /* not focusable */ } } }

  function makeReference() {
    var alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    var result = '';
    var source = window.crypto && window.crypto.getRandomValues ? new Uint32Array(7) : null;
    if (source) window.crypto.getRandomValues(source);
    for (var i = 0; i < 7; i += 1) {
      result += alphabet.charAt(source ? source[i] % alphabet.length : Math.floor(Math.random() * alphabet.length));
    }
    return 'SQ-' + result;
  }

  /* The utm_* parameters of the address the visitor arrived on, as one line for the lead email. */
  function campaignLine() {
    try {
      var params = new URLSearchParams(window.location.search);
      var parts = [];
      params.forEach(function (value, key) {
        if (/^utm_/i.test(key) && clean(value)) parts.push(key.toLowerCase() + '=' + clean(value));
      });
      return parts.join(' | ');
    } catch (e) { return ''; }
  }

  /* ---------- Webflow's anchor scroll ----------
     The theme loads the Webflow runtime (assets/h1-custom.js). Its jQuery handler on document ("click.wf-scroll") takes every
     same-page #id link and scrolls with no header offset. Remove that one handler now, when Webflow is ready, on DOMContentLoaded
     and on load. (Port of disableWebflowAnchorScroll() in uls-part-pdp.js.) */
  function disableWebflowAnchorScroll() {
    var off = function () {
      try { if (window.jQuery) window.jQuery(document).off('click.wf-scroll'); } catch (e) { /* no jQuery */ }
    };
    off();
    try { if (window.Webflow && typeof window.Webflow.push === 'function') window.Webflow.push(off); } catch (e) { /* no Webflow */ }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(off, 0); });
    window.addEventListener('load', off);
  }

  /* ---------- 1. Gallery ---------- */
  function initGallery(root) {
    var slides = all(root, '[data-usp-slide]');
    var thumbs = all(root, '[data-usp-thumb]');
    if (slides.length < 2 || !thumbs.length) return;
    function show(index) {
      slides.forEach(function (slide) {
        var on = slide.getAttribute('data-usp-slide') === String(index);
        slide.hidden = !on;
        var video = slide.querySelector('[data-usp-video]');
        if (video) {
          var frame = video.querySelector('iframe, video');
          if (on && !frame) {
            var tpl = video.querySelector('template[data-usp-video-embed]');
            if (tpl && tpl.content) {
              var poster = video.querySelector('img');
              if (poster) poster.hidden = true;
              video.appendChild(tpl.content.cloneNode(true));
            }
          } else if (!on && frame) {
            frame.parentNode.removeChild(frame);   /* stops the video when another image is chosen */
            var img = video.querySelector('img');
            if (img) img.hidden = false;
          }
        }
      });
      thumbs.forEach(function (thumb) {
        thumb.setAttribute('aria-pressed', thumb.getAttribute('data-usp-thumb') === String(index) ? 'true' : 'false');
      });
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { show(thumb.getAttribute('data-usp-thumb')); });
    });
  }

  /* ---------- 2. Links to the form: native scroll, then the first field gets focus ---------- */
  function initFormLinks(root) {
    var first = root.querySelector('#usp-quote input[name="name"]');
    all(root, '[data-usp-to-form]').forEach(function (link) {
      link.addEventListener('click', function () {
        if (!first) return;
        window.setTimeout(function () { safeFocus(first, true); }, 400);
      });
    });
  }

  /* ---------- 3. Quote form ---------- */
  function initForm(root) {
    var form = root.querySelector('.usp-form');
    var submit = form && form.querySelector('button[type="submit"]');
    if (!form || !submit) return;

    var status = form.querySelector('[data-usp-status]');
    var errorBox = form.querySelector('[data-usp-error]');
    var offBox = form.querySelector('[data-usp-off]');
    var success = root.querySelector('[data-usp-success]');
    var preview = root.getAttribute('data-preview') === 'true';
    var designMode = root.getAttribute('data-design-mode') === 'true';
    var accessKey = clean(root.getAttribute('data-web3forms-key'));
    var fallbackUrl = clean(root.getAttribute('data-fallback-url'));
    var handle = clean(root.getAttribute('data-handle'));
    var loadedAt = Date.now();
    var inflight = false;
    var reference = '';

    function field(name) { return form.querySelector('[name="' + name + '"]'); }
    function value(name) { var node = field(name); return clean(node && node.value); }

    function errorNode(input) {
      var ids = (input.getAttribute('aria-describedby') || '').split(/\s+/);
      for (var i = 0; i < ids.length; i += 1) {
        if (/-error$/.test(ids[i])) return document.getElementById(ids[i]);
      }
      return null;
    }
    function setFieldError(input, message) {
      var node = errorNode(input);
      input.setAttribute('aria-invalid', 'true');
      if (node) { node.textContent = message; node.hidden = false; }
    }
    function clearFieldError(input) {
      var node = errorNode(input);
      input.removeAttribute('aria-invalid');
      if (node) { node.hidden = true; node.textContent = ''; }
    }

    /* The page shows no phone number or email: every failure offers the contact form. */
    function appendContact(node, lead, tail) {
      if (!fallbackUrl) return;
      var link = document.createElement('a');
      link.href = fallbackUrl;
      link.textContent = 'send us a message';
      node.appendChild(document.createTextNode(lead));
      node.appendChild(link);
      node.appendChild(document.createTextNode(tail || '.'));
    }
    function clearFormError() {
      if (!errorBox) return;
      errorBox.hidden = true;
    }
    function showFormError(title, text, withContact) {
      if (!errorBox) return;
      var t = errorBox.querySelector('[data-usp-error-title]');
      var p = errorBox.querySelector('[data-usp-error-text]');
      if (t) t.textContent = title;
      if (p) {
        p.textContent = text;
        if (withContact) appendContact(p, text ? ' You can also ' : 'You can also ');
      }
      errorBox.hidden = false;
    }
    function showOff(text, withContact) {
      if (!offBox) return;
      var p = offBox.querySelector('[data-usp-off-text]');
      if (p) {
        p.textContent = text;
        if (withContact) appendContact(p, ' Please ', ' instead.');
      }
      offBox.hidden = false;
    }

    function validate() {
      var name = field('name');
      var email = field('email');
      var first = null;
      clearFormError();
      [name, email].forEach(function (input) { if (input) clearFieldError(input); });
      if (name && !clean(name.value)) {
        setFieldError(name, 'Enter your name so we know how to address you.');
        first = first || name;
      }
      if (email) {
        var emailValue = clean(email.value);
        if (!emailValue) {
          setFieldError(email, 'Enter your email so we can reply.');
          first = first || email;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
          setFieldError(email, 'Enter an email address like name@example.com so we can reply.');
          first = first || email;
        }
      }
      if (first) safeFocus(first);
      return !first;
    }

    ['name', 'email'].forEach(function (name) {
      var input = field(name);
      if (!input) return;
      var clear = function () { if (input.getAttribute('aria-invalid') === 'true') clearFieldError(input); };
      input.addEventListener('input', clear);
      input.addEventListener('change', clear);
    });

    function appendIfPresent(data, key, text) { if (text) data.append(key, text); }

    function makePayload() {
      var name = value('name');
      var company = value('company');
      var system = value('system') || 'Not sure yet';
      var menu = field('system');
      var chosen = menu && menu.options ? menu.options[menu.selectedIndex] : null;
      var systemHandle = chosen ? clean(chosen.getAttribute('data-handle')) : handle;   /* the chosen model's handle, not the page's */
      var work = field('application');
      var application = cleanLines(work && work.value);
      reference = reference || makeReference();
      var data = new window.FormData();
      data.append('access_key', accessKey);
      data.append('subject', 'ULS System Quote Request — ' + system + ' — ' + (company || name) + ' — ' + reference);
      data.append('from_name', 'Abernethy Beck — ULS System Quote');
      data.append('reference', reference);
      data.append('name', name);
      data.append('email', value('email'));
      appendIfPresent(data, 'company', company);
      appendIfPresent(data, 'phone', value('phone'));
      data.append('system', system);
      appendIfPresent(data, 'system_handle', systemHandle);
      data.append('page_handle', handle);
      appendIfPresent(data, 'replacing', value('replacing'));
      appendIfPresent(data, 'application', application);
      data.append('form', 'Machine page');
      appendIfPresent(data, 'campaign', campaignLine());
      data.append('page_url', window.location.href);
      data.append('botcheck', '');
      return { data: data, system: system, reference: reference };
    }

    function showSuccess(snapshot) {
      form.hidden = true;
      if (success) {
        var title = success.querySelector('[data-usp-success-title]');
        var detail = success.querySelector('[data-usp-success-detail]');
        if (title) title.textContent = snapshot.system === 'Not sure yet' ? 'Thanks. We have your quote request.' : 'Thanks. We have your quote request for the ' + snapshot.system + '.';
        if (detail) {
          detail.textContent = 'Your reference is ';
          var code = document.createElement('span');
          code.className = 'usp-ref';
          code.textContent = snapshot.reference;
          detail.appendChild(code);
          detail.appendChild(document.createTextNode('. We reply by email.'));
        }
        success.hidden = false;
        safeFocus(success);
        try { success.scrollIntoView({ block: 'nearest' }); } catch (e) { /* older browsers */ }
      }
      if (!preview && !designMode) {
        try {
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            window.Shopify.analytics.publish('abi_quote_submitted', {
              form_id: FORM_ID, reference: snapshot.reference, model: snapshot.system, parts_count: 0, units: 0
            });
          }
        } catch (ignore) { /* analytics must never break the form */ }
      }
    }

    function request(snapshot) {
      if (preview) return Promise.resolve({ ok: true, body: { success: true } });
      var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
      var timer = controller ? window.setTimeout(function () { controller.abort(); }, TIMEOUT) : null;
      return window.fetch(ENDPOINT, {
        method: 'POST', body: snapshot.data, headers: { Accept: 'application/json' }, signal: controller ? controller.signal : undefined
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          return { ok: response.ok, body: body };
        });
      }).finally(function () { if (timer) window.clearTimeout(timer); });
    }

    /* The button starts disabled in the markup. It stays off in the theme editor and while the section has no access key;
       either way the reason is said, so nobody faces a dead button without a way forward. */
    submit.disabled = !(preview || (accessKey && !designMode));
    if (designMode) {
      showOff('Sending is turned off in the theme editor.', false);
    } else if (submit.disabled) {
      showOff('This form isn’t set up yet.', true);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (inflight || submit.disabled) return;
      if (!validate()) return;
      var honeypot = field('botcheck');
      if (honeypot && clean(honeypot.value)) {
        showFormError('Your request didn’t send.', '', true);
        return;
      }
      if (Date.now() - loadedAt < MIN_PAGE_AGE) {
        showFormError('Please wait a moment, then send your request.', '', false);
        return;
      }
      var snapshot = makePayload();
      inflight = true;
      submit.disabled = true;
      if (status) status.textContent = 'Sending your request…';
      request(snapshot).then(function (result) {
        if (!result.ok || !result.body || result.body.success !== true) throw new Error('Request was not accepted');
        if (status) status.textContent = '';
        showSuccess(snapshot);
      }).catch(function () {
        /* What the visitor typed stays in the form, and the same reference is used when they try again. */
        if (status) status.textContent = '';
        showFormError('Your request didn’t send.', 'Check your connection and try again. Your answers are still here.', true);
        submit.disabled = false;
        safeFocus(submit);   /* the button was disabled while it had focus: give keyboard users their place back */
      }).then(function () {
        inflight = false;
      });
    });

    var again = success && success.querySelector('[data-usp-again]');
    if (again) {
      again.addEventListener('click', function () {
        reference = '';
        var keep = { system: value('system') };
        form.reset();
        if (field('system') && keep.system) field('system').value = keep.system;
        clearFormError();
        success.hidden = true;
        form.hidden = false;
        submit.disabled = !(preview || (accessKey && !designMode));
        var name = field('name');
        if (name) safeFocus(name);
      });
    }
  }

  function initialize(root) {
    if (!root || root.getAttribute('data-usp-ready') === 'true') return;
    root.setAttribute('data-usp-ready', 'true');
    root.classList.add('usp--js');
    initGallery(root);
    initFormLinks(root);
    initForm(root);
  }

  function initializeAll(scope) {
    if (scope && scope.matches && scope.matches('[data-usp]')) initialize(scope);
    all(scope || document, '[data-usp]').forEach(initialize);
  }

  disableWebflowAnchorScroll();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  else initializeAll(document);
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
}());
